import cookies from 'next-cookies'
import { NextPageContext } from 'next'
import { Config } from '@chegg-wt/core/config'
import { AppRouteCreators } from '../types/core'
import { routeToHref } from './routes'
import { Cookies } from './cookies'

export const shouldHideAds = (ctx: NextPageContext, routes: AppRouteCreators) => {
  const currentRoute = { href: ctx.pathname }
  const url = ctx.pathname ? routeToHref(currentRoute) : ''
  const isLogin = url.includes(routeToHref(routes.toLogin()))
  const isUpgrade = url.includes(routeToHref(routes.toUpgrade()))
  const isSignUp = url.includes(routeToHref(routes.toSignup()))
  const isMyAccount = url.includes(routeToHref(routes.toProfile()))
  // TODO: RGL-7703 - Valid for EB only may be extended to other sites in future
  const isProofReader =
    routes.toWritingAssistant && url.includes(routeToHref(routes.toWritingAssistant()))
  // want to disable ads for testcafe
  const test = cookies(ctx).robot_test

  if (isLogin || isUpgrade || isSignUp || isMyAccount || test || isProofReader) {
    return true
  }

  const { tpudsa, gateway } = cookies(ctx)

  if (tpudsa === 'tpudsa') {
    return true
  }

  if (gateway === 'true') {
    return true
  }

  return false
}

export const getAdConfigVersion = ({
  ctx,
  hideAds,
}: {
  ctx: NextPageContext
  hideAds: boolean
}) => (!hideAds && cookies(ctx)[Cookies.AdLayout] ? cookies(ctx)[Cookies.AdLayout] : null)

export const getError = (adConfigVersion: string, hideAds: boolean) =>
  !adConfigVersion && !hideAds ? 'ad cookie is not set.' : ''

export const getAdScript = ({
  ctx,
  routes,
  siteInitials,
  backendOpts,
}: {
  ctx: NextPageContext
  routes: AppRouteCreators
  siteInitials: string
  backendOpts?: any
}) => {
  const hideAds = shouldHideAds(ctx, routes)
  const adConfigVersion = getAdConfigVersion({ ctx, hideAds })
  let adScript = null

  if (backendOpts?.adConfigVersion && !hideAds)
    adScript = `https://atc-edge.studybreakmedia.com/bundles/${Config.archieLeague}/${siteInitials}/${backendOpts.adConfigVersion}.js`
  else if (adConfigVersion && !hideAds) {
    adScript =
      adConfigVersion === 'localhost'
        ? `https://localhost:3333/bundles/${Config.archieLeague}/${siteInitials}/localhost.js`
        : `https://atc-edge.studybreakmedia.com/bundles/${Config.archieLeague}/${siteInitials}/${adConfigVersion}.js`
  }

  return adScript
}

export const getDefaultAdScript = ({
  ctx,
  routes,
  siteInitials,
  adConfigVersion,
}: {
  ctx: NextPageContext
  routes: AppRouteCreators
  siteInitials: string
  adConfigVersion: string
}) => {
  const hideAds = shouldHideAds(ctx, routes)
  let adScript = null

  if (!hideAds && adConfigVersion) {
    adScript =
      adConfigVersion === 'localhost'
        ? `https://localhost:3333/bundles/${Config.archieLeague}/${siteInitials}/localhost.js`
        : `https://atc-edge.studybreakmedia.com/bundles/${Config.archieLeague}/${siteInitials}/${adConfigVersion}.js`
  }
  return adScript
}

export const getAllocatorScript = ({
  ctx,
  routes,
  siteInitials,
  backendOpts,
}: {
  ctx: NextPageContext
  routes: AppRouteCreators
  siteInitials: string
  backendOpts?: any
}) => {
  const hideAds = shouldHideAds(ctx, routes)
  const adConfigVersion = getAdConfigVersion({ ctx, hideAds })
  let adScript = null

  if (adConfigVersion && adConfigVersion === 'localhost') {
    adScript = `https://localhost:3333/bundles/${Config.archieLeague}/${siteInitials}/localhost.js`
  } else if (backendOpts?.adConfigVersion && !hideAds) {
    adScript = `https://atc-edge.studybreakmedia.com/bundles/${Config.archieLeague}/${siteInitials}/${backendOpts.adConfigVersion}.js`
  } else if (!hideAds) {
    adScript = `https://atc-edge.studybreakmedia.com/allocators/${Config.archieLeague}/${siteInitials}/allocator.js`
  }

  return adScript
}
